var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1.25,
    width: 30.5,
    height: 30.5,
    rx: 15.25,
    fill: "#FDF2ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1778 26.7397C9.12356 17.9592 8 17.0588 8 13.833C8 9.41434 11.5813 5.83301 16 5.83301C20.4187 5.83301 24 9.41434 24 13.833C24 17.0588 22.8764 17.9575 16.8222 26.7361C16.7303 26.8685 16.6077 26.9768 16.465 27.0516C16.3222 27.1265 16.1635 27.1658 16.0023 27.1661C15.8411 27.1665 15.6822 27.1279 15.5391 27.0536C15.396 26.9794 15.273 26.8717 15.1804 26.7397L15.1787 26.7361L15.1778 26.7397ZM16 17.1663C16.8841 17.1663 17.7319 16.8152 18.357 16.19C18.9821 15.5649 19.3333 14.7171 19.3333 13.833C19.3333 12.949 18.9821 12.1011 18.357 11.476C17.7319 10.8509 16.8841 10.4997 16 10.4997C15.1159 10.4997 14.2681 10.8509 13.643 11.476C13.0179 12.1011 12.6667 12.949 12.6667 13.833C12.6667 14.7171 13.0179 15.5649 13.643 16.19C14.2681 16.8152 15.1159 17.1663 16 17.1663Z",
    fill: "#E87A46"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1.25,
    width: 30.5,
    height: 30.5,
    rx: 15.25,
    stroke: "#E87A46",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOrange);
export default __webpack_public_path__ + "static/media/LocationOrange.947265a5e589b8d992cb17b6b3f9e37d.svg";
export { ForwardRef as ReactComponent };